import { render, staticRenderFns } from "./one-page-up-modal.vue?vue&type=template&id=1edff1d0&scoped=true&lang=pug&"
import script from "./one-page-up-modal.vue?vue&type=script&lang=js&"
export * from "./one-page-up-modal.vue?vue&type=script&lang=js&"
import style0 from "./one-page-up-modal.vue?vue&type=style&index=0&id=1edff1d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edff1d0",
  null
  
)

export default component.exports